import { render, staticRenderFns } from "./practicesDialog.vue?vue&type=template&id=7a5afbf8&"
import script from "./practicesDialog.vue?vue&type=script&lang=js&"
export * from "./practicesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports